import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LmsDetailComponent } from './lms-detail/lms-detail.component';
import { LmsListComponent } from './lms-list/lms-list.component';
import { StudentLmsReportComponent } from './student-lms-report/student-lms-report.component';
const routes: Routes = [
  {
    path: '',
    children: [
      { path: "", redirectTo: "list", pathMatch: "full" },
      {
        path: 'list', component: LmsListComponent
      },
      { path: 'detail/:name/:id', component: LmsDetailComponent },
      {path: 'student-lms-report',component: StudentLmsReportComponent}
    ],
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MeanderRbRoutingModule { }
